import Immutable from "immutable";
import * as types from "./constants";

const initialState = Immutable.fromJS({
  processLogIndexCheckedArray: [],
  formData: [],
  modalData: {},
  modalDataDetails: [],
  jsonModalData: { lhs: {}, rhs: {} },
  formDataJSON: {},
  tabularized: {},
  devices: [],
  submissionErrors: [],
  rangeFilter: "1 Months",
  stageFilter: "Any",
  errorFilter: "",
  searchFilter: "",
  showWirewalker: false,
  serverSearchFilter: "",
  isFetchingFormDataJSON: false,
  jsonFormModalOpen: false,
  changeModalOpen: false,
  changeOrderSubmissionID: -1,
  recallToDeviceModalOpen: false,
  isDeleteConfirmationOpen: false,
  recallDeviceResponse: {},
  isRecallingToDevice: false,
  isRecallToDeviceStatusModalOpen: false,
  makeTemplateDeviceResponse: {},
  makeTemplateToDeviceModalOpen: false,
  isSendingTemplateToDevice: false,
  isMakeTemplateToDeviceStatusModalOpen: false,
  deviceSelected: { device: "", type: "" },
  processLogSelectedRowIndex: 0,
  isFetchingDevices: false,
  isUpdatingProcessLog: false,
  processLogNewStatus: "",
  newSubmissionDateTime: "",
  formJsonModalSearchText: "",
  jsonModalDisplayLevels: 3,
  rowsUpdating: Immutable.Set(),
  isFetchingErrorList: false
});

function handleAction(state = initialState, action) {
  switch (action.type) {
    case types.CTD_PROC_DETAILS_MODAL_OPEN:
      return state.merge({
        processLogIndexCheckedArray: Immutable.fromJS([]),
        detailsModalOpen: true,
        processLogToggleSelectAll: false
      });

    case types.CTD_PROC_DETAILS_MODAL_CLOSE:
      return state.merge({
        detailsModalOpen: false,
        processLogToggleSelectAll: false,
        processLogIndexCheckedArray: [],
        processLogNewStatus: ""
      });

    case types.CTD_PROC_SEARCH_FILTER:
      return state.set("searchFilter", Immutable.fromJS(action.payload));

    case types.CTD_PROC_DETAILS_MODAL_SET_DATA:
      return state.set("modalData", Immutable.fromJS(action.payload.modalData));

    case types.CTD_PROC_RANGE_FILTER:
      return state.set("rangeFilter", Immutable.fromJS(action.payload));

    case types.CTD_PROC_STAGE_FILTER:
      return state.set("stageFilter", Immutable.fromJS(action.payload));

    case types.CTD_PROC_SHOW_WIREWALKER:
      return state.set("showWirewalker", Immutable.fromJS(action.payload));

    case types.CTD_PROC_DATA_FETCH_REQUEST:
      return state.merge({
        isFetching: true
      });
    case types.CTD_PROC_DATA_FETCH_SUCCESS:
      return state.merge({
        isFetching: false,
        formData: Immutable.fromJS(action.payload.formSubmissions)
      });
    case types.CTD_PROC_DATA_FETCH_ERROR:
      return state.merge({
        isFetching: false
      });

    default:
      return state;
  }
}

function fieldNotNull(value) {
  return !(typeof value === "undefined" || !value);
}

export function updateUrl(state) {
  const paramObj = new URLSearchParams();
  const validFields = [
    "rangeFilter",
    "stageFilter",
    "errorFilter",
    "searchFilter",
    "serverSearchFilter",
    "showWirewalker"
  ];

  // eslint-disable-next-line no-restricted-syntax
  for (const k of Array.from(state.keys()).filter(
    key => validFields.includes(key) && fieldNotNull(state.get(key))
  )) {
    paramObj.append(k, state.get(k));
  }

  const baseUrl = window.location.href.split("?")[0];
  const newUrl = `${baseUrl}?${paramObj.toString()}`;

  if (newUrl !== window.location.href) {
    window.history.pushState({}, "", `${baseUrl}?${paramObj.toString()}`);
  }
}

function statusReducer(state = initialState, action) {
  const updatedState = handleAction(state, action);

  if (state !== updatedState) {
    updateUrl(updatedState);
  }
  return updatedState;
}

export default statusReducer;
